import ArticleList from "../../../../src/components/ArticleList.jsx";
import * as React from 'react';
export default {
  ArticleList,
  React
};